const devConfig = {
  isProd: false,
  favicon: "console-dev",
  userLocalStorage: "cesiUserDev",
  apiEndpoint: 'https://sz3phydsli.execute-api.eu-west-1.amazonaws.com/v1',
  apiDbgToken: null, // change this to force apis to log stuff
  cognitoPoolId: 'eu-west-1_dDDMShBVQ',
  cognitoClientId: '7o1cs20qdiflgopg7bjs3ck1gj',
  cognitoRegion: 'eu-west-1',
  defaultBucketUrl: 'https://plus-cesi-repo-cloned.s3.eu-west-1.amazonaws.com/',
};

const prodConfig = {
  isProd: false,
  favicon: "console-dev",
  userLocalStorage: "cesiUserProd",
  apiEndpoint: 'https://4jxlq811x8.execute-api.eu-west-1.amazonaws.com/v1',
  apiDbgToken: null, // change this to force apis to log stuff
  cognitoPoolId: 'eu-west-1_BIkCJ1BMR',
  cognitoClientId: '7s7q5o9rcepn382tbrgs31kffb',
  cognitoRegion: 'eu-west-1',
  defaultBucketUrl: 'https://cesi-repo-sb-plus.s3.eu-west-1.amazonaws.com/',
};

export const getConfig = (field) => {

  switch(window.location.hostname){
    case "localhost":
    case "d38w142bjduiim.cloudfront.net": // staging
      return devConfig[field];
    default:
      return prodConfig[field];
  }
}

export const BREAKPOINT_XS = 768 - 1;
export const BREAKPOINT_SM = 992 - 1;
export const BREAKPOINT_MD = 1400 - 1;

export const LAYOUT_XS = "XS";
export const LAYOUT_SM = "SM";
export const LAYOUT_MD = "MD";
export const LAYOUT_LG = "LG";

export const PAGESIZE = 20;